<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <!--<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="true"></hamburger>-->

    <breadcrumb class="breadcrumb-container"></breadcrumb>

    <div class="right-menu">

      <error-log v-if="log.length>0" class="errLog-container right-menu-item" :logsList="log"></error-log>

      <!--<el-tooltip effect="dark" content="全屏" placement="bottom">-->
      <!--<screenfull class="screenfull right-menu-item"></screenfull>-->
      <!--</el-tooltip>-->
      <!--<el-dropdown trigger="click" class='international' @command="handleSetLanguage">-->
      <!--<div>-->
      <!--<svg-icon class-name='right-menu-item international-icon' icon-class="language"/>-->
      <!--</div>-->
      <!--<el-dropdown-menu slot="dropdown">-->
      <!--<el-dropdown-item command="zh" :disabled="language==='zh'">中文</el-dropdown-item>-->
      <!--<el-dropdown-item command="en" :disabled="language==='en'">English</el-dropdown-item>-->
      <!--</el-dropdown-menu>-->
      <!--</el-dropdown>-->

      <!--<el-tooltip effect="dark" content="换肤" placement="bottom">-->
      <!--<theme-picker class="theme-switch right-menu-item"></theme-picker>-->
      <!--</el-tooltip>-->

      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <!--<img class="user-avatar" :src="'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'+'?imageView2/1/w/80/h/80'">-->
          <!--<i class="el-icon-caret-bottom">admin</i>-->
          <span style="color:#bfcbd9">{{sysName}}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>

          <el-dropdown-item>
            <span @click="updatePassword()" style="display:block;">修改密码</span>
          </el-dropdown-item>

          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出登录</span>
            <!--<span style="display:block;">退出登录</span>-->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogUpdatePassword" title="修改密码" width="50%" center>
      <el-form ref="psform" :model="psform" :rules="rules" label-width="200px">
        <el-form-item label="帐号:">
          <span>{{sysName}}</span>
        </el-form-item>

        <el-form-item label="原密码:" prop="oldpassword">
          <el-input type="password" v-model="psform.oldpassword" style="width: 50%"></el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="password">
          <el-input type="password" v-model="psform.password" style="width: 50%"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="password2">
          <el-input type="password" v-model="psform.password2" style="width: 50%"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commitUpdateButton('psform')">确定</el-button>
        <el-button @click="dialogUpdatePassword = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-menu>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import ThemePicker from '@/components/ThemePicker'
  import Screenfull from '@/components/Screenfull'
  import ErrorLog from '@/components/ErrLog'
  import errLogStore from '../../../store/errLog'
  import {getName} from '@/utils/auth'
  import {updatePass, adminLoginOut} from '@/api/login'

  export default {
    components: {
      Breadcrumb,
      Hamburger,
      ThemePicker,
      ErrorLog,
      Screenfull
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.psform.password2 !== '') {
            this.$refs.psform.validateField('password2');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.psform.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }

      return {
        log: errLogStore.state.errLog,
        sysName: getName(),
        dialogUpdatePassword: false,
        psform: {
          oldpassword: '',
          password: '',
          password2: '',
        },
        rules: {
          oldpassword: [
            {required: true, message: '请输入原密码', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
            {validator: validatePass, trigger: 'blur'}
          ],
          password2: [
            {required: true, message: '请再次确认新密码', trigger: 'blur'},
            {validator: validatePass2, trigger: 'blur'}
          ],
        }

      }
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'name',
//        'avatar',
        'language'
      ])
    },
    methods: {
      commitUpdateButton(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            console.log('submit!')
            updatePass(this.psform).then(res => {
              if (res.data.status === 'success') {
                this.$message.success('修改成功')
                this.dialogUpdatePassword = false
              } else {
                this.$message.error('修改失败')
              }
            })
          } else {
            return false;
          }
        })
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
        //     console.log('submit!')
        //     updatePass(this.psform).then(res => {
        //       if (res.data.status === 'success') {
        //         this.$message.success('修改成功')
        //         this.dialogUpdatePassword = false
        //       } else {
        //         this.$message.success('修改失败')
        //       }
        //     })
        //   } else {
        //     return false;
        //   }
        // });

        console.log(this.psform)

      },
      updatePassword() {
        // this.$refs[formName].resetFields();
        this.psform = {
          oldpassword: '',
          password: '',
          password2: '',
        }
        this.dialogUpdatePassword = true
      },
      toggleSideBar() {
        this.$store.dispatch('toggleSideBar')
      },
      handleSetLanguage(lang) {
        this.$i18n.locale = lang
        this.$store.dispatch('setLanguage', lang)
        this.$message({
          message: 'switch language success',
          type: 'success'
        })
      },
      logout() {
//        adminLoginOut().then(res => {
//
//        })
        this.$store.dispatch('LogOut').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      }
    }

  }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    background: #293039;

    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }

    .breadcrumb-container {
      float: left;
    }

    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }

    .right-menu {
      float: right;
      height: 100%;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }

      .screenfull {
        height: 20px;
      }

      .international {
        vertical-align: top;

        .international-icon {
          font-size: 20px;
          cursor: pointer;
          vertical-align: -5px;
        }
      }

      .theme-switch {
        vertical-align: 15px;
      }

      .avatar-container {
        height: 50px;
        margin-right: 30px;

        .avatar-wrapper {
          cursor: pointer;
          margin-top: 5px;
          position: relative;

          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue